import { useLocation } from "react-router-dom";

import { useSessionStore } from "@tudigo-monorepo/tudigo-session";

export function useIsHelperVisible() {
  const location = useLocation();
  const { helperConfiguration } = useSessionStore();

  const isHelperVisible = helperConfiguration?.helperPages?.some((page) => {
    return location.pathname === page.uri;
  });

  return isHelperVisible;
}
